import React, { FC, ReactNode } from 'react';
import { Typography, IconButton, Box } from '@mui/material';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import type { ComponentProps } from 'react';

interface DialogTitleProps {
  children?: ReactNode;
  onClose?: () => void;
}

export const DialogTitle: FC<DialogTitleProps> = ({ children, onClose, ...other }) => {
  return (
    <Box
      component="div"
      {...other}
      sx={{
        margin: 0,
        padding: (theme) => theme.spacing(2),
        paddingBottom: (theme) => theme.spacing(2),
        position: 'relative',
        '& .closeButton': {
          position: 'absolute',
          right: (theme) => theme.spacing(1),
          top: (theme) => theme.spacing(1),
          color: (theme) => theme.palette.primary.main,
        },
      }}
    >
      <Typography variant="h6" component="div" color="primary">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="large"
          className="closeButton"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </Box>
  );
};

export const DialogContent: FC<ComponentProps<typeof MuiDialogContent>> = (props) => (
  <MuiDialogContent {...props} />
);

export const DialogActions: FC<ComponentProps<typeof MuiDialogActions>> = (props) => (
  <MuiDialogActions {...props} />
);
